import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

import GlobalService from "@/services/global-service";
import AppToolbar from "@/components/AppToolbar.vue";
import SnackbarType from "@/types/enums/snackbar-type";
import CookieConsentBanner from "@/components/CookieConsentBanner.vue";
import AppBottomNav from "@/views/AppBottomNav.vue";
import useStore from "@/stores";
import {computed, onMounted} from "vue";
import SnowOverlay from "@/components/SnowOverlay.vue";

enum Month {
  JANUARY = 0,
  DECEMBER = 11
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { chatwoot } = useStore();

const snackbarVisible = GlobalService.snackbar().snackbarVisible;
const snackbarMessage = GlobalService.snackbar().snackbarMessage;
const snackbarColor = GlobalService.snackbar().snackbarColor;

const letItSnow = computed<boolean>(() => {
  const month: number = new Date().getMonth();

  return month === Month.DECEMBER || month === Month.JANUARY;
});

onMounted(async () => {
  await chatwoot.init();
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(AppToolbar),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(AppBottomNav),
      (letItSnow.value)
        ? (_openBlock(), _createBlock(SnowOverlay, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(CookieConsentBanner),
      _createVNode(_component_v_snackbar, {
        modelValue: _unref(snackbarVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(snackbarVisible) ? (snackbarVisible).value = $event : null)),
        color: _unref(snackbarColor),
        top: "",
        right: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(snackbarMessage)) + " ", 1),
          (_unref(snackbarColor) === _unref(SnackbarType).LOADING)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                indeterminate: true,
                rounded: "",
                height: "6"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "color"])
    ]),
    _: 1
  }))
}
}

})